$(function() {

	$.nette.ext('radioChoices', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: '.js-radio-choices',
		init: function($el) {
			$el.find(this.selector)
				.each(function() {
					var $this = $(this)
					setTimeout(() => {
						var $labels = $this.find('.js-radio-choices__label');
						var $radios = $this.find('[type="radio"]');

						$this.find('[type="radio"][disabled]')
							.closest('.js-radio-choices__label')
							.addClass('js-radio-choices__label--disabled');

						$radios
							.on('change', function () {
								var $label = $(this).closest('.js-radio-choices__label');
								var className = 'js-radio-choices__label--active';

								$labels.removeClass(className);
								$label.addClass(className);
							})
							.filter(':checked')
							.triggerHandler('change');
					}, 0)
				});
		}
	});

});
